// Constructor
// file is a SWFUpload file object
// targetID is the HTML element id attribute that the RamJetFileProgress HTML structure will be added to.
const RamJetFileProgress = function (file, targetID, width) {
  this.fileProgressID = file.id;
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    "/": '&#x2F;',
  };
  var reg = /[&<>"'/]/ig;
  this.fileName = file.name.replace(reg, (match)=>(map[match]));

  this.fileProgressWrapper = jQuery("#" + this.fileProgressID);
  if (this.fileProgressWrapper.length == 0) {
    var progressHtml = "";
    progressHtml = progressHtml + '<div class="ramJetProgressWrapper file-input__item" id="' + this.fileProgressID + '">';
    progressHtml = progressHtml + '<div class="progressContainer file-input__content">';
    progressHtml = progressHtml + '<a href="#" class="progressCancel file-input__btn file-input__btn--cancel"></a>';
    progressHtml = progressHtml + '<div class="progressName file-input__name">' + this.fileName + '</div>';
    progressHtml = progressHtml + '<div class="file-input__progress progress"><div class="progressBar progressBarInProgress progress__bar"/></div>';
    progressHtml = progressHtml + '<div class="progressBarStatus file-input__progress-status"></div>';
    // progressHtml = progressHtml + '<a href="#" class="fileIds_remove fileRemove file-input__item-remove" data-file-id="' + this.fileProgressID + '"><span class="ico ico--close"><svg class="svg-icon"><use xlink:href="#close-thin"></use></svg></span></a>';
    progressHtml = progressHtml + '</div>';
    progressHtml = progressHtml + '</div>';
    var jProgressHtml = jQuery(progressHtml);
    if (width !== null && width !== undefined) {
      jProgressHtml.css("width", width);
    }
    jProgressHtml.insertBefore("#" + targetID);
    this.fileProgressWrapper = jQuery("#" + this.fileProgressID);
  }
  this.fileProgressElement = this.fileProgressWrapper.children(".progressContainer");
  this.fileProgressElement.find(".progressName").html('<span class="file-type file-type--' + this.fileName.split('.').pop() + '"><span class="file-type__ico ico"><svg class="svg-icon"><use xlink:href="#file-' + this.fileName.split('.').pop() + '"></use></svg></span>' + this.fileName + '</span>');
}

RamJetFileProgress.prototype.setProgress = function (percentage) {
  this.fileProgressElement.attr("class", "progressContainer green file-input__content file-input__content--progress");
  this.fileProgressElement.children(".progressBar")
    .attr("class", "progressBar progressBarInProgress progress__bar")
    .css("width", percentage + "%");
};
RamJetFileProgress.prototype.setComplete = function (ms) {
  this.appear();
  ms = ms !== undefined ? ms : 10000;
  this.fileProgressElement.attr("class", "progressContainer blue file-input__content file-input__content--complete");
  this.fileProgressElement.children(".progressBar")
    .attr("class", "progressBar progressBarComplete progress__bar")
    .css("width", "");

  var oSelf = this;
  if (ms > 0) {
    setTimeout(function () {
      oSelf.disappear();
    }, ms);
  }
};
RamJetFileProgress.prototype.setError = function (ms) {
  this.appear();
  ms = ms !== undefined ? ms : 5000;

  this.fileProgressElement.attr("class", "progressContainer red file-input__content file-input__content--error");
  this.fileProgressElement.children(".progressBar")
    .attr("class", "progressBar progressBarError progress__bar")
    .css("width", "");

  var oSelf = this;
  var cancelBtn = this.fileProgressElement.find(".progressCancel");
  cancelBtn.show();
  cancelBtn.click(function () {
    oSelf.disappear();
    return false;
  });
  if (ms > 0) {
    setTimeout(function () {
      oSelf.disappear();
    }, ms);
  }
};

RamJetFileProgress.prototype.setCancelled = function (ms) {
  ms = ms || 2000;
  this.appear();

  this.fileProgressElement.attr("class", "progressContainer red file-input__content file-input__content--canceled");
  this.fileProgressElement.children(".progressBar")
    .attr("class", "progressBar progressBarError progress__bar")
    .css("width", "");

  var oSelf = this;
  setTimeout(function () {
    oSelf.disappear();
  }, ms);
};
RamJetFileProgress.prototype.setStatus = function (status) {
  this.fileProgressElement.find(".progressBarStatus").html(status);
};

RamJetFileProgress.prototype.setLabel = function(label) {
  this.fileProgressElement.find(".progressName").html(label);
}

// Show/Hide the cancel button
RamJetFileProgress.prototype.toggleCancel = function (show, swfUploadInstance) {
  var cancelBtn = this.fileProgressElement.find(".progressCancel");
  if (show) {
    cancelBtn.show();
  } else {
    cancelBtn.hide();
  }
  if (swfUploadInstance) {
    var fileID = this.fileProgressID;
    cancelBtn.click(function () {
      swfUploadInstance.cancelUpload(fileID);
      return false;
    });
  }
};

// Makes sure the RamJetFileProgress box is visible
RamJetFileProgress.prototype.appear = function () {
  this.fileProgressWrapper.show("slow");
};

// Fades out and clips away the RamJetFileProgress box.
RamJetFileProgress.prototype.disappear = function () {
  var wrapperToRemove = this.fileProgressWrapper;
  this.fileProgressWrapper.hide("slow", function() {wrapperToRemove.remove()});
};

module.exports = RamJetFileProgress;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/plUpload/fileProgressBar.js